// PBs locais (modo convidado / offline). Migram pra conta na F4.
const KEY = 'surfrun.pbs.v1';

type PBStore = Record<string, number>; // slug → ms

function load(): PBStore {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? '{}') as PBStore;
  } catch {
    return {};
  }
}

export function getPB(slug: string): number | null {
  const v = load()[slug];
  return typeof v === 'number' ? v : null;
}

export function allPBs(): Record<string, number> {
  return load();
}

// --- fila de envios pendentes (offline / servidor sem banco) ---
const PENDING_KEY = 'surfrun.pending.v1';

export interface PendingRun {
  mapSlug: string; timeMs: number; stageTimesMs: number[]; maxSpeed: number; physicsVersion: number;
}

export function getPending(): PendingRun[] {
  try {
    return JSON.parse(localStorage.getItem(PENDING_KEY) ?? '[]') as PendingRun[];
  } catch {
    return [];
  }
}

export function setPending(list: PendingRun[]): void {
  try {
    localStorage.setItem(PENDING_KEY, JSON.stringify(list.slice(-30)));
  } catch { /* sem storage */ }
}

export function pushPending(run: PendingRun): void {
  setPending([...getPending(), run]);
}

/** Grava se for melhor; retorna true se melhorou o PB. */
export function submitTime(slug: string, timeMs: number): boolean {
  const store = load();
  const prev = store[slug];
  if (typeof prev === 'number' && prev <= timeMs) return false;
  store[slug] = timeMs;
  try {
    localStorage.setItem(KEY, JSON.stringify(store));
  } catch { /* storage cheio/indisponível — PB só em memória nesta sessão */ }
  return true;
}
